export default __webpack_public_path__ + "media/images/vehicle-350x220-acd26f38c3b9ba38b7ed24036fde56a1.jpg";